export default "__VITE_ASSET__DMhkZcT4__"